/**
 * @Author: Zero
 * @Date: 2023-12-26 09:55:14
 * @Explain: 活动报表 - 中文
 */

export default {
  // 跳转活动详情失败提示
  'ACTIVITY.REPORT.TO.DETAIL.FAIL.TRY': '活动不存在',
  // 列表
  'ACTIVITY.REPORT.TITLE': '活动报表',
  'ACTIVITY.REPORT.SUB.TITLE': '报表总览',
  'ACTIVITY.REPORT.ACTIVITY.STATUS.ON.GOING': '发送中',
  'ACTIVITY.REPORT.ACTIVITY.STATUS.COMPLETED': '已结束',
  'ACTIVITY.REPORT.ACTIVITY.CAMPAIGN': '活动',
  'ACTIVITY.REPORT.ACTIVITY.GROUP': '活动组',
  'ACTIVITY.REPORT.ACTIVITY.GROUP.BUBBLE.1':
    '活动组为您整合活动数据并生成合并报表。',
  'ACTIVITY.REPORT.ACTIVITY.GROUP.BUBBLE.2':
    '不同活动中的相同收件人将独立统计，不进行合并。',
  'ACTIVITY.REPORT.LIST.GROUP.TITLE': '活动组列表',
  'ACTIVITY.REPORT.ACTIVITY.GROUP.LOADING.TEXT': '正在加载数据{num}秒…',
  'ACTIVITY.REPORT.LIST.NAME': '活动名称',
  'ACTIVITY.REPORT.LIST.CLASSIFICATION': '分类',
  'ACTIVITY.REPORT.LIST.STATUS': '状态',
  'ACTIVITY.REPORT.LIST.SEND.DATE': '发送日期',
  'ACTIVITY.REPORT.LIST.RECIPIENT': '收件人',
  'ACTIVITY.REPORT.LIST.SENT': '已发送',
  'ACTIVITY.REPORT.LIST.FORMULA.SENT': '发送率 = 已发送/收件人',
  'ACTIVITY.REPORT.LIST.DELIVERED': '已送达',
  'ACTIVITY.REPORT.LIST.FORMULA.DELIVERED': '送达率 = 送达量/已发送',
  'ACTIVITY.REPORT.LIST.OPENED': '打开',
  'ACTIVITY.REPORT.LIST.FORMULA.OPENED': '打开率 = 打开量/送达量',
  'ACTIVITY.REPORT.LIST.CLICKED': '点击',
  'ACTIVITY.REPORT.LIST.FORMULA.CLICKED': '打开点击率 = 点击量/打开量',
  'ACTIVITY.REPORT.LIST.ACTION.VIEW': '查看报告',
  'ACTIVITY.REPORT.VIEW.DETAILS': '活动详情',
  'ACTIVITY.REPORT.VIEW.REPORT': '查看报表',
  'ACTIVITY.REPORT.LIST.STATUS.CYCLE': '周期{num}',
  'ACTIVITY.REPORT.LIST.GROUP.UPDATE.DATA': '更新数据',
  'ACTIVITY.REPORT.LIST.GROUP.UPDATE.DATA.TIPS': '上次更新：{time}',
  'ACTIVITY.REPORT.LIST.NO.ACTIVITY.GROUP.TIPS': '组内无活动',
  'ACTIVITY.REPORT.LIST.EXPORT': '导出报表',
  'ACTIVITY.REPORT.LIST.GROUP.CREATE': '创建活动组',
  'ACTIVITY.REPORT.LIST.GROUP.EDIT': '编辑活动组',
  'ACTIVITY.REPORT.LIST.GROUP.NAME': '活动组名称',
  'ACTIVITY.REPORT.LIST.GROUP.NAME.PLACEHOLDER': '输入组名称',
  'ACTIVITY.REPORT.LIST.GROUP.CAMPAIGN.BUBBLE': '只有常规活动可以被分组',
  'ACTIVITY.REPORT.LIST.GROUP.NAME.REPEAT': '名称重复，请重新命名',
  'ACTIVITY.REPORT.LIST.GROUP.CAMPAIGN': '活动',
  'ACTIVITY.REPORT.LIST.GROUP.CAMPAIGN.SEARCH': '搜索活动',
  'ACTIVITY.REPORT.LIST.GROUP.NAME.LIMIT': '请输入活动组名称，上限{num}字符',
  'ACTIVITY.REPORT.LIST.GROUP.CAMPAIGN.LIMIT': '选择活动',
  'ACTIVITY.REPORT.LIST.GROUP.CAMPAIGN.MAX.ACTIVITY': '已达到最大数量限制',
  'ACTIVITY.REPORT.LIST.GROUP.DEL.TITLE': '确定删除活动组？',
  'ACTIVITY.REPORT.LIST.GROUP.DEL.DESC':
    '删除 <span class="color-primary font-weight-700">{name}</span> 后，活动组信息不可恢复。',
  // 详情
  'ACTIVITY.REPORT.DETAIL.SEARCH.ACTIVITY': '切换活动',
  'ACTIVITY.REPORT.DETAIL.SEARCH.ACTIVITY.PLACEHOLDER': '请输入活动名称',
  'ACTIVITY.REPORT.DETAIL.SEARCH.PERIOD': '切换周期',
  'ACTIVITY.REPORT.DETAIL.SEARCH.PERIOD.PLACEHOLDER': '请输入周期名称',
  'ACTIVITY.REPORT.DETAIL.SELECT.ACTIVITY': '选择活动',
  // Overview
  'ACTIVITY.REPORT.DETAIL.TAB.OVERCIEW': '概览',
  'ACTIVITY.REPORT.DETAIL.TAB.CLICK.PERFORMANCE': '点击表现',
  'ACTIVITY.REPORT.DETAIL.REGION': '地区',
  // Deliverability
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.TITLE': '送达能力',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.DESC':
    '这部分递送指标描述您的邮件活动投递到用户收件服务的数据表现，通常与您的联系人列表质量、发信域名信誉度相关。 <a href="{url}" target="_blank">查看更多</a>',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.IN.BACKLOG': '堆积{num}',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.DELIVERY.TITLE': '送达',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.DELIVERY.RECIPIENTS':
    '收件人',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.DELIVERY.DESC.RECIPIENTS':
    '活动设置的收件人数量',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.DELIVERY.SENT': '已发送',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.DELIVERY.DESC.SENT':
    '已发送的邮件的数量',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.DELIVERY.DELIVERED': '已送达',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.DELIVERY.DESC.DELIVERED':
    '已成功送达用户邮箱服务器的消息数量',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.DELIVERY.RATE.TITLE.DELIVERED':
    '送达率',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.DELIVERY.RATE.FORMULA.DELIVERED':
    '送达率 = 送达量/已发送',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.DELIVERY.DELIVERED.DESC':
    '送达率 <span class="font-size-14 color-333 font-weight-700">{deliverRate}</span>',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.FILTERED': '过滤',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.FILTERED.DETAILS':
    '过滤详情',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.FILTERED.BY.FILTERED.L':
    '{filtered}个联系人被',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.FILTERED.BY.FILTERED.C':
    '拒绝列表',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.FILTERED.BY.FILTERED.R':
    '过滤',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.FILTERED.BY.RULEFILTRATIONNUM':
    '{filtered}个联系人被<a href="{url}" target="_blank" style="text-decoration: none;">SLHP</a>过滤（SmartLink列表卫生保护）',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.FILTERED.BY.STRATEGY.L':
    '{strategyCount}个联系人被',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.FILTERED.BY.STRATEGY.C':
    '防打扰策略',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.FILTERED.BY.STRATEGY.R':
    '过滤',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.BACKLOGS.DESC':
    'ISP的限制导致延迟投递',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.BACKLOGS':
    '队列积压',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.SOFT.BOUNCE':
    '软反弹',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.SOFT.BOUNCE.DESC':
    '通常是暂时的问题（例如：收件人的收件箱已满）',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.HARD.BOUNCE':
    '硬反弹',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.HARD.BOUNCE.DESC':
    '通常是一个永久性问题（例如，不存在地址）',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.TITLE': '未送达分析',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.EXPORT.EMAIL':
    '导出未送达邮件',
  'PLACEHOLDER.REPORT.Export.DIALOG.HEADER': '确认导出未送达邮件?',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.VIEW.MORE':
    '查看更多',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.NOT.SENT': '未发送',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.BOUNCED': '反弹',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.DETAILS': '详情',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.COUNT': '数量',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.PERCENTAGE': '占比',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.DESC': '描述',
  // Email engagement
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.TITLE': '邮件参与',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.DESC':
    '这部分指标反映您的邮件/活动内容是否足够吸引受众。',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.OPENED': '打开',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.CLICKED': '点击',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.UNSUB': '取消订阅',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.RATE': '比率',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.AFTER': '后续',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.VIEW.DETAILS':
    '查看国家和语种的数据分布',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.ENG.RES': '参与结果',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.CTOR': '点击率',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.INFO.OPENED': '比率',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.INFO.DESC.OPENED':
    '打开率=已打开/已送达',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.INFO.CLICKED': '点击率',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.INFO.DESC.CLICKED':
    '点击率=点击量/打开量',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.INFO.UNSUB': '比率',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.INFO.DESC.UNSUB':
    '取消订阅率=取消订阅量/打开量',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.BENCHMARKS.TITLE': '基准对比',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.BENCHMARKS.INFO':
    '查看此活动和项目活动、平台活动对比效果，也可选择项目中特定活动加入对比。(少于50个收件人的活动不计入其中)',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.BENCHMARKS.DESC': '比较活动效果',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.BENCHMARKS.TAB1': '打开率',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.BENCHMARKS.TAB2': '点击率',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.BENCHMARKS.TAB3': '取消订阅率',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.BENCHMARKS.COMPARE':
    '选择要比较的活动',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.BENCHMARKS.ACTIVITY.PERFORMANCE':
    '展示项目内其他活动表现',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.BENCHMARKS.PERF': '此活动表现',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.BENCHMARKS.AVG':
    '此项目的平均活动表现',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.BENCHMARKS.BETTERS.AVG':
    '平台内其他项目的平均活动表现',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.BENCHMARKS.BETTER':
    '表现优于<span class="font-weight-700">此项目以往活动</span>的比例',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.BENCHMARKS.BETTERS':
    '表现优于<span class="font-weight-700">平台内所有活动</span>的比例',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.BENCHMARKS.ACTIVITY.TYPE':
    '对比数据的活动目的',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.BENCHMARKS.ACTIVITY.TYPE.OTHER':
    '不区分活动目的',

  // Conversions
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.CONVER.TITLE': '转化',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.CONVER.DESC':
    '这部分指标措迹您的活动最终转化效果，需要通过 <a href="{ url }" target="_blank">SmartLink API</a> 连接您的应用内数据',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.CONVER.GUIDE.TITLE':
    '深入分析您的电子邮件性能',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.CONVER.GUIDE.DESC':
    '深入研究对你最重要的指标。绘制这些指标的图表，并查看它们随时间推移的性能。',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.CONVER.INDIC.METRIC': '选择一个要追踪的指标',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.CONVER.INDIC.NAME': 'API 名称',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.CONVER.INDIC.FILEDS.REQ': '是否必须',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.CONVER.INDIC.READY': '已准备',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.CONVER.GUIDE.BTN': '自定义指标',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.CONVER.REGISTERED': '注册用户',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.CONVER.ACTIVE': '活跃用户',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.CONVER.PAY': '付费用户',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.CONVER.CLOUMNS.1': '注册用户',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.CONVER.CLOUMNS.2': '活跃用户',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.CONVER.CLOUMNS.3': '付费用户',
  'ACTIVITY.REPORT.DETAIL.COUNT': '总计',
  // Click performance
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.TITLE': '点击总览',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.OPEN.TITLE': '点击率',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.OPEN.DESC.UC': ' 独立点击 ',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.OPEN.DESC.UQ': ' 独立打开',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.STATIS.TITLE': '统计详情',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.STATIS.TITLE.NEW': '分栏视图',
  'ACTIVITY.REPORT.DEFAULT.LANGUAGE': '默认',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.BY.URL': '按URL查看',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.BY.LABEL': '按标签查看',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.LIST': '列表视图',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP': '热力图视图',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.PREVIEW.TITLE':
    '邮件预览',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.CLICK.SUMMARY':
    '点击概览',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.TOTAL.CLICK.SUMMARY.BY.LANG':
    '总点击数',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.TOTAL.CLICK.SUMMARY.BY.LANG.DES':
    '点击的总次数。如果一人点击了 3 次，此处记为 3。',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.UNIQUE.CLICK.SUMMARY.BY.LANG':
    '独立点击数',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.UNIQUE.CLICK.SUMMARY.RATE':
    '点击占比',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.UNIQUE.CLICK.SUMMARY.BY.LANG.DES':
    '点击的人数。如果一人点击了 3 次，此处记为 1。',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.LIST.TITLE':
    '热门 URL 排名',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.LIST.HEADER.URL':
    '链接地址',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.CLICK.INTENSITY':
    '点击热度',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.LEAST.CLICKS': '点击最少',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.MOST.CLICKS': '点击最多',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.LIST.HEADER.CLICK':
    '总点击数',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.LIST.HEADER.CLICK.PERCENTAGE':
    '(点击占比)',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.LIST.HEADER.CLICK.UNIQUE':
    '独立点击数',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.HOVER.TOTAL.TIP':
    '总点击数 {num} ({clickPercent})',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.HOVER.UNIQUE.TIP':
    '独立点击数 {num} ({clickPercent})',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.HOVER.HOT.TIP':
    '高频点击 ({num})',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.HOVER.MIDDLE.TIP':
    '中频点击 ({num})',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.HOVER.COLD.TIP':
    '低频点击 ({num})',

  // 下载邮件截图相关
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.HOTMAP.DOWNLOAD.BTN': '下载热力图',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.HOTMAP.DOWNLOAD.PNG': 'PNG（高清）',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.HOTMAP.DOWNLOAD.JPG': 'JPG（较小体积）',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.HOTMAP.DOWNLOAD.NO.DATA':
    '当前语言暂无点击数据可导出',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.HOTMAP.DOWNLOAD.LOADING':
    '预览加载中…',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.HOTMAP.DOWNLOAD.GENERATING':
    '正在生成热力图…',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.HOTMAP.DOWNLOAD.GENERATING.STEP':
    '正在截取画布 · 第 {current} 步 / 共 {total} 步',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.HOTMAP.DOWNLOAD.SUCCESS': '热力图已下载',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.HOTMAP.DOWNLOAD.MISSING.IMAGE':
    '部分图片可能未加载完整',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.HOTMAP.DOWNLOAD.OVERSIZE.SUGGEST.PNG':
    '邮件较长，JPG 超过 10MB，建议用 PNG 导出画质更清晰。',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.HOTMAP.DOWNLOAD.FAILED':
    '下载失败，请重试。',
  // PNG 导出图内嵌文案（固定英文，避免乱码）
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.HOTMAP.DOWNLOAD.PNG.HEADER':
    '{campaign} · {lang} · {date} · {clicks} clicks',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.HOTMAP.DOWNLOAD.PNG.WATERMARK':
    'SmartLink Heatmap · Generated {date}',

  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.BY.EMAIL.LANG': '按模板语种查看',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.BY.URL.DESC':
    '查看所有标签和语种下的URL点击数据',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.BY.LABEL.DESC':
    '分标签查看标签对应的URL点击数据。标签可在模板中设置，也可在此设置。',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.BY.LABEL.DESC.GO': '去设置',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.BY.EMAIL.LANG.DESC':
    '分语种查看对应语种模板中的URL点击数据',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.LABEL': '标签',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.EMAIL.LANG': '邮件语种',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.TOTAL.CLICKS': '总点击',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.UNIQUE.CLICKS': '独立点击',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.CLICK.OPEN': '点击率',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.SEARCH.URL': '请输入URL',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.EDIT.URL': '编辑邮件中的URL标签',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.ALL.LANG': '所有邮件语言',
  // In-game Behavior Analysis
  'ACTIVITY.REPORT.DETAIL.TAB.BEHAVIOR': '游戏内行为分析',

  // AB Test报表
  'ACTIVITY.REPORT.VIEW.SETUP.BTH.TITLE': '查看设置内容',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.EMAIL': '查看邮件',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.DETAIL.BUTTON': '查看测试组',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.STATUS.2': '测试已结束',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.STATUS.4': '测试进行中',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.STATUS.5': '测试暂停',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.STATUS.7': '测试已完成',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SEND.TIME': '发送时间 {sendTime}',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.EXP.NUM':
    '<span class="mark">{expGroupNum}</span>组',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.LANG.NUM':
    '<span class="mark">{langNum}</span>种语言划分',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST': 'A/B测试表现',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.CAMP': '活动表现',

  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST.WIN.SELECT.TIP.OPERATE.PAUSE':
    '活动被暂停',

  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST.WIN.SELECT.TIP.OPERATE.DISABLED':
    '活动被手动终止',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST.WIN.SELECT.TIP.OPERATE.TEST.ON.GOING':
    '等待手动选择,',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST.WIN.SELECT.TIP.OPERATE.TEST.ON.GOING.FINISH':
    '在<span class="mark">{time}</span>之前，等待手动选择,',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST.WIN.SELECT.TIP.OPERATE.REMAIN.ON.GOING.FINISH':
    '测试组<span class="mark">{winner}</span>（对于{lang}收件人）已经被选为获胜组，其余收件人在<span class="mark">{time}</span>发送{point}',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST.WIN.SELECT.TIP.OPERATE.REMAIN.ON.GOING.FINISH.NO.LANG':
    '测试组<span class="mark">{winner}</span>已经被选为获胜组，其余收件人在<span class="mark">{time}</span>发送{point}',

  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST.WIN.SELECT.TIP.AUTO.TEST.ON.GOING':
    '获胜组计划在测试完成后 <span class="mark">{time}</span> 后发送,',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST.WIN.SELECT.TIP.AUTO.TEST.ON.GOING.FINISH':
    '获胜组计划在 <span class="mark">{time}</span>  发送,',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST.WIN.SELECT.TIP.AUTO.REMAIN.ON.GOING.FINISH':
    '实验组<span class="mark">{winner}</span> （对于{lang}收件人）已经被选为获胜组，其余收件人在<span class="mark">{time}</span>发送{point}',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST.WIN.SELECT.TIP.AUTO.REMAIN.ON.GOING.FINISH.NO.LANG':
    '实验组<span class="mark">{winner}</span> 已经被选为获胜组，其余收件人在<span class="mark">{time}</span>发送{point}',

  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST.WIN.SELECT.DETAIL.SUFFIX':
    '(查看详情)',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST.WIN.SELECT.CONVERT.SUFFIX':
    '转换为手动选择',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST.WIN.SELECT.CONVERT.SUFFIX.AUTO':
    '发送完成后可手动选择',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST.WIN.SELECT.NOW.SUFFIX':
    '现在选择',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST.WIN.SELECT.DISABLED':
    '请等待测试结束后手动选择',

  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST.WIN.SELECT.COMPETITION': '竞赛',

  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.LANG.ALL': '所有语言',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.ALL': '所有',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.BY.LANG': '语言',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.REGION.ALL': '所有地区',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.BY.REGION': '地区',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND': '趋势',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.DETAIL': '详情',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.TYPE.OPEN.RATE': '打开率',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.TYPE.CLICK.RATE': '点击率',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.TYPE.SENT.RATE': '递送率',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.TYPE.UNSUB.RATE': '取消订阅率',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.CYCLE.HOUR': '按小时',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.CYCLE.HOUR.TIP': '{num} 小时',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.CYCLE.DAY': '按天',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.CYCLE.DAY.TIP': '{num} 天',

  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.DETAIL.TABLE.LANG': '语言',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.DETAIL.TABLE.WINNER': '获胜组',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.DETAIL.TABLE.SUBJECT': '主题',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.DETAIL.TABLE.PREVIEW': '预览文本',

  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.DETAIL.TABLE.SETUP': '测试组',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.DETAIL.TABLE.RECIPIENT':
    '收件人数量',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.DETAIL.TABLE.DELIVER': '发送数量',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.DETAIL.TABLE.DELIVER.RATE': '送达率',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.DETAIL.TABLE.OPEN.RATE': '打开率',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.DETAIL.TABLE.CTOR.RATE': '点击率',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.DETAIL.TABLE.UNSUB.RATE':
    '取消订阅率',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.DETAIL.CHECK.TIP':
    '投递有问题？检查活动表现',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.COMPARE': '选择并对照',

  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.COMPARE.SELECT.TIP': '对比',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.COMPARE.SELECT.BY': '按',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.COMPARE.SELECT.LANG': '语言',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.COMPARE.SELECT.REGION': '地区',

  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.TITLE': '选择获胜组',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.DISABLE.SELECT':
    '必须选择所有语言的获胜设置',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.CONTENT.TITLE':
    '测试分组设置',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.CONTENT.SUBTITLE':
    '您可以根据用户特征将测试分为几组，独立确定每组的获胜者并自动将获胜者传递给相应的组',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.DILIVER.LANG':
    '按语言划分',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.DILIVER.SWITCH.OPEN':
    '组织语言',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.DILIVER.LANG.TIP':
    "我们将把以下语言合并到一个“<span class='mark'>其他</span>”组中，确保每个设置都有足够的收件人",
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.OTHERS': '其他',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.TABLE.OTHERS': '其他',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.OTHERS.TIP': '合并语言',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.DISABLED.SPLIT': '禁用',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.LANG.SPLIT':
    '按语言划分',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.TABLE.SETUP': '实验组',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.LINE.SETUP':
    '测试组{num}',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.TIP.SETUP': '测试组',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.TABLE.RECIPIENT':
    '收件人数量',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.TABLE.SENT': '发送数量',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.TABLE.DILIVERED':
    '送达数量',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.TABLE.DILIVERED.RATE':
    '送达率',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.TABLE.OPEN.RATE':
    '打开率',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.TABLE.CTOR.RATE':
    '点击率',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.TABLE.UNSUB.RATE':
    '取消订阅率',

  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.CAMPAIGN.ALL': '整个活动',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.CAMPAIGN.ONLY.AB':
    '只统计 A/B test 部分',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.CAMPAIGN.EXCLUDE.AB':
    '排除 A/B test 部分',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.LINE.START': '开始',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.LINE.NOW': '现在',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.LINE.HOUR': '小时',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.LINE.DAY': '天',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.LINE.END': '结束',

  'ACTIVITY.REPORT.VIEW.SETUP.DETAILS.TITLE': '测试组配置说明',
  'ACTIVITY.REPORT.VIEW.SETUP.DETAILS.STEUP.NUMBER': '测试数量：',
  'ACTIVITY.REPORT.VIEW.SETUP.DETAILS.DEFAULT.LANG': '默认语言：',
  'ACTIVITY.REPORT.VIEW.SETUP.DETAILS.VARIATIONS': '测试组',
  'ACTIVITY.REPORT.VIEW.SETUP.DETAILS.GROUP.SIZES': '测试组比例预览',
  'ACTIVITY.REPORT.VIEW.SETUP.DETAILS.SUBJECT': '主题',
  'ACTIVITY.REPORT.VIEW.SETUP.DETAILS.PREVIEW.TEXT': '预览文本',
  'ACTIVITY.REPORT.AB.TEST.DETAIL.OVERCIEW.EMAIL.BENCHMARKS.BETTER':
    '表现优于<span class="font-weight-700">此项目以往活动</span>的比例',
  'ACTIVITY.REPORT.AB.TEST.DETAIL.OVERCIEW.EMAIL.BENCHMARKS.BETTERS':
    '表现优于<span class="font-weight-700">平台内所有活动</span>的比例',
  'ACTIVITY.REPORT.AB.TEST.SRTIP.SUBJECT': '实验{num}',
  'ACTIVITY.REPORT.AB.TEST.CONVER.TREND.TITLE.1': '注册用户变化趋势',
  'ACTIVITY.REPORT.AB.TEST.CONVER.TREND.TOTAL.1': '注册用户数',
  'ACTIVITY.REPORT.AB.TEST.CONVER.TREND.RATE.1': '用户注册率',
  'ACTIVITY.REPORT.AB.TEST.CONVER.TREND.TITLE.2': '活跃用户变化趋势',
  'ACTIVITY.REPORT.AB.TEST.CONVER.TREND.TOTAL.2': '活跃用户数',
  'ACTIVITY.REPORT.AB.TEST.CONVER.TREND.RATE.2': '用户活跃率',
  'ACTIVITY.REPORT.AB.TEST.CONVER.TREND.TITLE.3': '付费用户变化趋势',
  'ACTIVITY.REPORT.AB.TEST.CONVER.TREND.TOTAL.3': '付费用户数',
  'ACTIVITY.REPORT.AB.TEST.CONVER.TREND.RATE.3': '用户付费率',

  // 周期活动选中全部周期抽屉
  'ACTIVITY.REPORT.CYCLE.ALL': '全部周期',
  'ACTIVITY.REPORT.RECCURING.REPORT.TITLE': '周期活动报表',
  'ACTIVITY.REPORT.RECCURING.REPORT.ALL.CYCLE.TITLE': '全部周期',
  'ACTIVITY.REPORT.RECCURING.REPORT.ALL.CYCLE.DESC':
    '全部周期的指标数据为单个周期指标数据的简单合并加和。不会对相同联系人做数据合并，只会对同一数据指标进行合并加和。',
  'ACTIVITY.REPORT.RECCURING.REPORT.EMAIL.PART.TITLE': '邮件参与',
  'ACTIVITY.REPORT.RECCURING.REPORT.EMAIL.PART.DESC':
    '全部周期的参与结果，为对多个周期参与结果的数据合并。例如D1的数据计算方式为所有周期的D1的数据加和。',
  'ACTIVITY.REPORT.RECCURING.REPORT.REMBER.BOX': '不再自动展开此说明',

  // abTest v4.0.0报表详情
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.BANNER.ACTION.SELECT.NOW': '立即选择',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.BANNER.ACTION.SWITCH.MANUAL':
    '切换为手动选择获胜组',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.BANNER.ACTION.VIEW.DETAILS':
    '查看所有语言详情',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.BANNER.ACTION.RESTART.CAMPAIGN':
    '重新启动活动',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.BANNER.1': '等待手动选择。',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.BANNER.2':
    '获胜组将在测试阶段完成后 <b class="color-000">{intervalTime} {intervalTypeText}</b> 时系统自动选择并投放。',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.BANNER.3':
    '等待手动选择（截止时间：<b class="color-000">{expNodeTime}</b>）。',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.BANNER.4':
    '获胜组将于 <b class="color-000">{expNodeTime}</b> 开始投放。',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.BANNER.5':
    '已选择方案 <b class="color-000">{winnerExpNum}</b>作为获胜组，并于 <b class="color-000">{expNodeTime}</b> 开始向剩余收件人投放。',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.BANNER.6':
    '已选择方案 <b class="color-000">{winnerExpNum}</b>作为获胜组（语言：<b class="color-000">{winnerExpLang}</b>），并于 <b class="color-000">{expNodeTime}</b> 开始向剩余收件人投放。',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.BANNER.7':
    '活动已于 <b class="color-000">{suspendTime}</b> 暂停。',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.BANNER.8':
    '变量值缺失，活动发送中断。点击资源码名称为其上传变量值：',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.BANNER.9':
    '活动已由 <b class="color-000">{terminateBy}</b> 于 <b class="color-000">{terminateTime}</b> 终止',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.BANNER.10':
    '所有收件人均已加入测试组，因此不会进行获胜方案选择及后续投放。',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.BANNER.11': '实验已结束。',
  /** 报表 - 导出链接点击次数页面相关 **/
  'ACTIVITY.REPORT.LINKS.CLICKED.TITLE': '链接点击详情',
  'ACTIVITY.REPORT.LINKS.CLICKED.SEARCH.PLACEHOLDER': '搜索邮箱',
  'ACTIVITY.REPORT.LINKS.CLICKED.EXPORT.BUTTON': '导出为 CSV',
  'ACTIVITY.REPORT.LINKS.CLICKED.EXPORT.DIALOG.CONTENT':
    '您确定要导出<b class="color-333">{campaignName}</b>的点击详情吗?',
  'ACTIVITY.REPORT.LINKS.CLICKED.EXPORT.DIALOG.HEADER': '确认导出',
  'ACTIVITY.REPORT.LINKS.CLICKED.EXPORT.ENTER.BUTTON': '导出',
  'ACTIVITY.REPORT.LINKS.CLICKED.EXPORT.COLUMNS.EMAIL.ADDRESS.TITLE':
    '用户邮箱',
  'ACTIVITY.REPORT.LINKS.CLICKED.EXPORT.COLUMNS.TIMESTAMP.TITLE': '时间戳',
  'ACTIVITY.REPORT.LINKS.CLICKED.EXPORT.COLUMNS.URL.TITLE': '链接网址',
  'ACTIVITY.REPORT.LINKS.CLICKED.CREATED.EXPORT.REQUEST.SUCCESS':
    '导出任务提交成功，请到<b class="color-primary">导出中心</b>下载文件',
  'ACTIVITY.REPORT.LINKS.CLICKED.CREATED.EXPORT.REQUEST.FAILED':
    '导出失败请重试',

  // Conversions
  'ACTIVITY.REPORT.DETAIL.TAB.CONVERSION': '游戏转化',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.VS':
    '相比 <b class="color-333">{value} 对照组</b>的提升',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.CONV': '转化率',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.ARPPU': '单个付费玩家平均收益',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.ARPU': '单个玩家平均收益',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.AVG': '平均活跃天数',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.INCREMENTAL': '增量',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.CUMULATIVE': '累计',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.ACTIVE': '	Active',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.UPLIFT': '	提升率',
  // 'ACTIVITY.REPORT.DETAIL.CONVERSION.UPLIFT.VALUE': '	Uplift {symbol}{value}',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.PAYING': '	Paying',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.RENENUE': 'Revenue',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.DAY': '第{num}天',

  'ACTIVITY.REPORT.DETAIL.CONVERSION.TITLE': '转化表现',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.DESC':
    '追踪您的邮件活动如何随时间影响游戏内互动和收益。',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.PLAYER.TYPE.ALL': '全部',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.PLAYER.TYPE.ALL.SUFIX': '全部送达玩家',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.PLAYER.TYPE.ACTIVE': '活跃',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.PLAYER.TYPE.ACTIVE.SUFIX': '活动前活跃',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.PLAYER.TYPE.CHURNED': '流失',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.PLAYER.TYPE.CHURNED.SUFIX': '活动前流失',

  'ACTIVITY.REPORT.DETAIL.CONVERSION.INDICTOR.AVTIVE.TITLE': '活动后活跃玩家',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.INDICTOR.AVTIVE.TREND.TITLE':
    '活跃玩家趋势',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.INDICTOR.AVTIVE.0.TREND.SERIES.NAME':
    '活跃玩家数',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.INDICTOR.AVTIVE.1.TREND.SERIES.NAME':
    '活跃玩家数 (活动前 7 天活跃)',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.INDICTOR.AVTIVE.2.TREND.SERIES.NAME':
    '活跃玩家数 (活动前 7 天流失)',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.INDICTOR.PAYING.TITLE': '活动后付费玩家',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.INDICTOR.PAYING.TREND.TITLE':
    '付费玩家趋势',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.INDICTOR.PAYING.TREND.SERIES.NAME':
    '付费玩家数',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.INDICTOR.REVENUE.TITLE': '活动后收益',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.INDICTOR.REVENUE.TREND.TITLE': '收益趋势',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.INDICTOR.REVENUE.TREND.SERIES.NAME':
    '收益金额',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.INDICTOR.TREND.DESC.INCREMENTAL':
    '近 7 日每日增量变化',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.INDICTOR.TREND.DESC.CUMULATIVE':
    '7天累计增长',
  // 气泡公共配置
  'ACTIVITY.REPORT.DETAIL.CONVERSION.BUBBLE.FORMULA': '公式: ',
  // 活跃用户气泡：总数
  'ACTIVITY.REPORT.DETAIL.CONVERSION.AVTIVE.0.BUBBLE.TITLE':
    '活动后活跃玩家（全部送达玩家）',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.AVTIVE.0.BUBBLE.DESC':
    '在活动发送后 7 天内活跃的玩家总数',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.AVTIVE.1.BUBBLE.TITLE':
    '活动后活跃玩家（活动前活跃）',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.AVTIVE.1.BUBBLE.DESC':
    '活动前 7 天处于活跃状态，且在活动发送后 7 天内保持活跃的独立玩家总数。',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.AVTIVE.2.BUBBLE.TITLE':
    '活动后活跃玩家（活动前流失）',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.AVTIVE.2.BUBBLE.DESC':
    '活动前 7 天处于流失状态，但在活动发送后 7 天内转为活跃（回流）的玩家总数。',

  // 活跃用户气泡：上涨
  'ACTIVITY.REPORT.DETAIL.CONVERSION.INCREASED.BUBBLE.TITLE': '增量提升',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.AVTIVE.INCREASED.BUBBLE.DESC':
    '由营销活动带来的预估活跃玩家增长。它通过对比实验组 (90%)与对照组 (10%)的绩效差异，有效剔除了自然增长的干扰。',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.AVTIVE.INCREASED.BUBBLE.NOTES.1':
    '提升率=（送达组提升率-对照组提升率）/对照组提升率',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.AVTIVE.INCREASED.BUBBLE.NOTES.2':
    '提升活跃人数=（已送达提升率 - 对照组提升率）*已送达人数',

  // 活跃用户气泡：转化率
  'ACTIVITY.REPORT.DETAIL.CONVERSION.AVTIVE.0.RATE.BUBBLE.DESC': '',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.AVTIVE.0.RATE.BUBBLE.NOTES':
    '活跃率=活跃玩家/全部送达玩家',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.AVTIVE.1.RATE.BUBBLE.DESC': '',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.AVTIVE.1.RATE.BUBBLE.NOTES':
    '活跃玩家数 (活动前 7 天活跃) / 所有已送达玩家数 (活动前 7 天活跃)',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.AVTIVE.2.RATE.BUBBLE.DESC': '',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.AVTIVE.2.RATE.BUBBLE.NOTES':
    '活跃玩家数 (活动前 7 天流失) / 所有已送达玩家数 (活动前 7 天流失)',

  // 活跃用户气泡：平均数
  'ACTIVITY.REPORT.DETAIL.CONVERSION.AVTIVE.AVG.BUBBLE.TITLE': '平均活跃天数',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.AVTIVE.AVG.BUBBLE.DESC':
    '活动发送后 7 天内，每位玩家的平均活跃天数。该指标反映了参与深度，以及活动在促使玩家持续回归游戏方面的效果。',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.AVTIVE.AVG.BUBBLE.NOTES':
    '平均活跃天数=活跃玩家的活跃总天数/全部已送达玩家',

  // 付费气泡
  // 付费气泡：上涨
  'ACTIVITY.REPORT.DETAIL.CONVERSION.PAYING.INCREASED.BUBBLE.DESC':
    '由营销活动带来的预估付费玩家增长。它通过对比送达组 (90%)与对照组 (10%)的绩效差异，有效剔除了自然增长的干扰。',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.PAYING.INCREASED.BUBBLE.NOTES.1':
    '提升率 = （已送达付费率 - 对照组付费率）/对照组付费率',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.PAYING.INCREASED.BUBBLE.NOTES.2':
    '提升人数=（已送达付费率 - 对照组付费率）*已送达人数',

  // 付费气泡：比率
  'ACTIVITY.REPORT.DETAIL.CONVERSION.PAYING.RATE.BUBBLE.NOTES':
    '付费率=付费玩家/全部送达玩家',

  // 金额气泡
  // 金额气泡：上涨
  'ACTIVITY.REPORT.DETAIL.CONVERSION.REVENUE.INCREASED.BUBBLE.DESC':
    '由营销活动带来的预估付费金额增长。它通过对比送达组 (90%)与对照组 (10%)的绩效差异，有效剔除了自然增长的干扰。',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.REVENUE.INCREASED.BUBBLE.NOTES.1':
    '提升率 = （已送达人均付费金额 - 对照组人均付费金额）/对照组人均付费金额',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.REVENUE.INCREASED.BUBBLE.NOTES.2':
    '提升金额=（已送达付费人均金额 - 对照组付费人均金额 ）* 已送达人数',

  // 金额气泡：ARPPU
  'ACTIVITY.REPORT.DETAIL.CONVERSION.REVENUE.ARPPU.BUBBLE.DESC': '',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.REVENUE.ARPPU.BUBBLE.NOTES':
    '=活动后总收益/付费人数',

  // 金额气泡：ARPU
  'ACTIVITY.REPORT.DETAIL.CONVERSION.REVENUE.ARPU.BUBBLE.DESC': '',
  'ACTIVITY.REPORT.DETAIL.CONVERSION.REVENUE.ARPU.BUBBLE.NOTES':
    '=活动后总收益/已送达人数',

  'ACTIVITY.REPORT.DETAIL.CONVERSION.SEGMENT':
    'View detailed breakdown by segment',
};
